export default __webpack_public_path__ + "static/media/Hands_Black_Aqua.17001b17.png";